module.exports = __webpack_public_path__ + "static/pattern-washed_medium.a2e9f72e.png";